module.exports = __webpack_public_path__ + "img/rectangle-fill-green.06fbb111.svg";